module.exports = __webpack_public_path__ + "static/media/suitcase-rolling.251c93cf.svg";